module.exports = __webpack_public_path__ + "static/7-b0ce22090d530f6f88098a100efaff2a.jpg";